import styled from 'styled-components';
import bgMain from '@assets/images/bg-main.svg';

const Wrapper = styled.div`
  background-image: url(${bgMain});
  background-attachment: fixed;
  background-repeat: no-repeat;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  padding-left: 2rem;
  padding-right: 2rem;
`;

const Container = styled.div`
  position: relative;

  &:before {
    content: '';
    width: 95%;
    z-index: -1;
    transform: translatey(35px);
    border-radius: 1.3rem;
    position: absolute;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    margin-top: -1rem;
    height: 100%;
    background-color: rgb(255, 255, 255, 0.1);
  }
`;
const ContainerBox = styled.div`
  transform: translatey(35px);
  display: flex;
  border-radius: 1.3rem;
  background-color: #1a3175;
`;

export const El = {
  Wrapper,
  Container,
  ContainerBox
};
